// Сурлага — сурагч өөрийн (/study), эцэг эх "Хүүхэд" хуудсанд (who = хүүхдийн id).
// Улирлын дүн (зөвхөн гаргасан) + PDF тайлан, хичээл бүрийн карт (лого · нэр · дүн) → /study/c/:courseId.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Spin, message } from "antd";
import { FiCheckCircle, FiChevronRight, FiDownload, FiMail } from "react-icons/fi";
import dayjs from "dayjs";
import { instance } from "utils/axios";
import { get, base, qs, TermChips } from "./shared";
import SubjectIcon from "components/SubjectIcon";
import { PblCards } from "./Pbl";
import SignaturePad from "pages/Consent/SignaturePad";

// Эцэг эх: улирлын тайланг имэйлээр авах, тайлантай танилцсанаа гарын үсгээр баталгаажуулах
function ReportActions({ who, d, onAck }) {
  const [busy, setBusy] = useState(null);
  const [open, setOpen] = useState(false);
  const [sig, setSig] = useState(null);
  const post = (url, data) => instance({ method: "post", url: `${base(who)}${url}`, data: { termId: d.term.id, ...data }, silent: true }).then((r) => r.data);
  const email = () => {
    setBusy("email");
    post("/report/email").then((r) => message.success(`${r.to} хаяг руу илгээлээ`)).catch((e) => message.error(e?.response?.data?.error || "Илгээж чадсангүй")).then(() => setBusy(null));
  };
  const sign = () => {
    setBusy("ack");
    post("/report/ack", { signatureImage: sig }).then((r) => { onAck(r.ack); setOpen(false); message.success("Баталгаажууллаа"); })
      .catch((e) => message.error(e?.response?.data?.error || "Баталгаажуулж чадсангүй")).then(() => setBusy(null));
  };
  return (
    <>
      <button type="button" onClick={email} disabled={!!busy} className="pchip pchip-off !h-9 flex items-center gap-1.5"><FiMail /> {busy === "email" ? "Илгээж байна…" : "Имэйлээр авах"}</button>
      {d.ack
        ? <span className="pchip !h-9 flex items-center gap-1.5 bg-[#dcfce7] text-[#166534] border-0" title={`${d.ack.signerName} · ${dayjs(d.ack.agreedAt).format("YYYY-MM-DD HH:mm")}`}><FiCheckCircle /> Танилцсан · {dayjs(d.ack.agreedAt).format("MM/DD")}</span>
        : <button type="button" onClick={() => setOpen(true)} className="pchip pchip-on !h-9 flex items-center gap-1.5"><FiCheckCircle /> Танилцсанаа баталгаажуулах</button>}
      <Modal open={open} onCancel={() => setOpen(false)} title={`${d.term.name}ын тайлантай танилцсан`} footer={[
        <Button key="c" onClick={() => setOpen(false)}>Болих</Button>,
        <Button key="s" type="primary" loading={busy === "ack"} disabled={!sig} onClick={sign}>Баталгаажуулах</Button>,
      ]}>
        <p className="text-sm">Би {who === "me" ? "" : "хүүхдийнхээ "}{d.term.name}ын сурлагын тайлантай{who === "me" ? "гаа" : ""} (хичээл бүрийн дүн, суралцахуйн үр дүн, багшийн зөвлөмж) танилцлаа.</p>
        <div className="text-xs text-gray-500 mb-1">Гарын үсгээ зурна уу</div>
        <SignaturePad onChange={setSig} />
      </Modal>
    </>
  );
}


export function LearningOverview({ who, compact = false }) {
  const [term, setTerm] = useState(null);
  const [d, setD] = useState(null);
  useEffect(() => {
    let alive = true;
    setD(null);
    get(base(who), term ? { termId: term } : {}).then((x) => alive && setD(x)).catch(() => alive && setD({ error: true }));
    return () => { alive = false; };
  }, [who, term]);

  if (!d) return <div className="flex justify-center py-10"><Spin /></div>;
  if (d.error) return <div className="tj-card p-6 text-sm text-gray-500">Сурлагын мэдээлэл татаж чадсангүй.</div>;
  const q = qs(who, term);
  // Дүн гарсан хичээл эхэнд (дүнгээр), гараагүй нь доор
  const sorted = [...d.courses].sort((a, b) => (b.termTotal != null) - (a.termTotal != null) || (b.termTotal ?? 0) - (a.termTotal ?? 0) || a.subject.localeCompare(b.subject));
  const list = compact ? sorted.filter((c) => c.termTotal != null).slice(0, 6) : sorted;
  const published = d.courses.filter((c) => c.termTotal != null).length;

  return (
    <div className="flex flex-col gap-3.5">
      <section className="tj-card p-4 md:p-5 flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[160px] flex flex-col">
          <div className="text-xs font-bold uppercase tracking-wide text-gray-500">Голч дүн · {d.term.name}</div>
          <div className="num font-extrabold text-[56px] md:text-[64px] leading-none text-primary mt-1">{d.termAvg == null ? "—" : `${Math.round(d.termAvg)}%`}</div>
          <div className="text-sm text-gray-500 mt-1">{published ? `(${published} хичээлийн дундаж)` : "Улирлын дүн хараахан гараагүй байна"}</div>
        </div>
        {d.reportReady ? (
          <div className="flex flex-wrap gap-2">
            <Link to={`/study/report?${q}`} className="pchip pchip-off !h-9 flex items-center gap-1.5"><FiDownload /> Тайлан PDF</Link>
            {<ReportActions who={who} d={d} onAck={(ack) => setD((x) => ({ ...x, ack }))} />}
          </div>
        ) : <span className="text-xs text-gray-400">Улирлын тайлан багш нийтлэхэд гарна</span>}
      </section>
      {!compact && <TermChips terms={d.terms} value={d.term.id} onChange={setTerm} />}
      {!list.length ? (
        <div className="tj-card p-6 text-sm text-gray-500 text-center">Улирлын дүн хараахан гараагүй байна.</div>
      ) : (
        <div className="grid gap-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((c) => (
            <Link key={c.courseId} to={`/study/c/${c.courseId}?${q}`} className={`tj-card !rounded-xl px-3 py-2 flex items-center gap-2.5 !text-[#1c1c1c] hover:bg-[#faf7ff] ${c.termTotal == null ? "opacity-70" : ""}`}>
              <SubjectIcon name={c.subject} size={36} />
              <span className="flex-1 min-w-0 block text-sm font-bold truncate">{c.subject}</span>
              <span className="text-right">
                {c.termTotal != null
                  ? <span className="block text-lg font-bold tabular-nums text-primary">{Math.round(c.termTotal)}%</span>
                  : <span className="block text-xs text-gray-400">Дүн гараагүй</span>}
              </span>
              <FiChevronRight className="text-primary shrink-0" />
            </Link>
          ))}
        </div>
      )}
      {compact && <Link to="/study" className="text-sm font-semibold self-start">Бүх хичээл →</Link>}
      {!compact && <PblCards who={who} />}
    </div>
  );
}

export default function Study() {
  return (
    <div className="pt-4 md:pt-8 pb-8 max-w-[1180px] mx-auto w-full flex flex-col gap-4">
      <h1 className="m-0 text-[26px] md:text-[34px] font-extrabold text-primary leading-tight">Сурлага</h1>
      <LearningOverview who="me" />
    </div>
  );
}
